import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Button, Menu, MenuItem, Stack } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import TranslateIcon from '@mui/icons-material/Translate';
import { object } from 'yup';
import { TLanguages, changeLanguage, languages } from '../../localization';
import Span from '../../shared/component/Span';

interface ILanguageProps {}

const Language = (props: ILanguageProps) => {
    const { t } = useTranslation();

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleChangeLanguage = (language: TLanguages) => {
        changeLanguage(language);
        handleClose();
    };

    return (
        <Stack>
            <Button
                variant='greenLight'
                startIcon={<TranslateIcon />}
                id='language-button'
                endIcon={<KeyboardArrowDownIcon />}
                aria-controls={open ? 'language-menu' : undefined}
                aria-haspopup='true'
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}>
                <Span text={t('language')} />
            </Button>
            <Menu
                id='language-menu'
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'language-button',
                }}>
                {Object.keys(languages).map(x => (
                    <MenuItem key={languages[x as TLanguages]} onClick={() => handleChangeLanguage(x as TLanguages)}>
                        {languages[x as TLanguages]}
                    </MenuItem>
                ))}
            </Menu>
        </Stack>
    );
};

export default Language;
